export function getPositionMilliseconds(position: number, sampleRate: number) {
  return Math.round((1000 * position) / sampleRate)
}
